const CellCustomerDetail: React.FC<{ data: any }> = ({ data }) => {

    return (
        <>{data['customer_name']}<br /><small>{data['mobile_number']}</small></>
    )
}

export default CellCustomerDetail;